import Email from "./email"
import Container from "./container"
import Content from "./content"
import Editable from "./editable"
import BuiltWith from "./built-with"
import MsoSnippet from "./mso-snippet"
import OutlookOnly from "./outlook-only"
import OutlookSpacingTable from "./outlook-spacing-table"
import ExceptOutlook from "./except-outlook"
import BackgroundColor from "./background-color"
import BackgroundImage from "./background-image"
import Section from "./section"

export default {
  "ck-email": Email,
  "ck-container": Container,
  "ck-content": Content,
  "ck-editable": Editable,
  "ck-built-with": BuiltWith,
  "mso-snippet": MsoSnippet,
  "outlook-only": OutlookOnly,
  "outlook-spacing-table": OutlookSpacingTable,
  "except-outlook": ExceptOutlook,
  "background-color": BackgroundColor,
  "background-image": BackgroundImage,
  "ck-section": Section
}
